import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { Toggle } from "@onshopfront/components";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import Button from "../../../Common/Buttons/Button";
import { setOption } from "../../../Utilities/Platform/Options/Options";

const connector = connect();

interface Props extends ConnectedProps<typeof connector> {
    id: string;
    name: string;
    to: string;
    dispatch: ThunkDispatch<any, any, any>;
}

interface State {
    remember: boolean;
}

export class ApplicationRedirect extends React.Component<Props, State> {
    public state = {
        remember: false,
    };

    protected handleRememberChange = (e: React.FormEvent<HTMLInputElement>): void => {
        this.setState({
            remember: e.currentTarget.checked,
        });
    };

    protected handleCancel = (): void => {
        if(this.state.remember) {
            setOption(`client_${this.props.id}_redirect`, false);
        }

        this.props.dispatch(hideDialog());
    };

    protected handleRedirect = (): void => {
        if(this.state.remember) {
            setOption(`client_${this.props.id}_redirect`, true);
        }

        window.location.href = this.props.to;

        this.props.dispatch(hideDialog());
    };

    public render(): React.ReactNode {
        let toURL: string | URL = this.props.to;

        try {
            toURL = new URL(this.props.to);
            toURL = `${toURL.origin}${toURL.pathname}`;
        } catch {
            // Do nothing, just use the original URL
        }

        return (
            <div className="application-download">
                <p>
                    An application ({this.props.name}) is attempting to redirect you to an external site,
                    (<span title={this.props.to}>{toURL.toString()}</span>), would you like to be redirected?
                </p>
                <label className="flex items-center gap-2">
                    <Toggle
                        onChange={this.handleRememberChange}
                        checked={this.state.remember}
                    />
                    Remember my choice
                </label>
                <div className="buttons">
                    <Button
                        classes={[ "button-cancel" ]}
                        onClick={this.handleCancel}
                    >
                        Ignore
                    </Button>
                    <Button
                        classes={[ "button-primary" ]}
                        onClick={this.handleRedirect}
                    >
                        Redirect
                    </Button>
                </div>
            </div>
        );
    }
}

export default connector(ApplicationRedirect);
